import { render, staticRenderFns } from "./soundsbtn.vue?vue&type=template&id=ad3b589c&"
import script from "./soundsbtn.vue?vue&type=script&lang=js&"
export * from "./soundsbtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports